import { useContext } from 'react';
import useWebSocket, { ReadyState } from 'react-use-websocket';

import { trackWsConnectionError } from '../../hooks/use-session-tracker';

import { ConnectionErrorVariant, GlobalContext } from '../global-provider';

export const useWebSocketConnection = (
  socketUrl: string | null,
  resolveConnectionErrorVariant: () => ConnectionErrorVariant,
  onMessage: (message: MessageEvent<any>) => void,
) => {
  const { setShowReloadMessage, setConnectionErrorVariant } = useContext(GlobalContext);

  const MAX_RECONNECT_ATTEMPTS = 5;

  const { sendMessage, readyState } = useWebSocket(socketUrl, {
    share: true,
    onMessage,
    reconnectAttempts: MAX_RECONNECT_ATTEMPTS,
    reconnectInterval: 5000,
    shouldReconnect: () => true,
    retryOnError: true,
    onOpen: () => {
      console.log('WebSocket Connected');
    },
    onError: (error: any) => {
      console.error('WebSocket Error:', error);
      trackWsConnectionError('socket_error', {
        message: error?.message ?? 'unknown_error',
        readyState,
      });
    },
    onClose: (event) => {
      console.log('WebSocket Disconnected');

      if (!event.wasClean || event.code !== 1000) {
        trackWsConnectionError('socket_disconnected', {
          code: event.code,
          reason: event.reason || 'no_reason_provided',
          wasClean: event.wasClean,
        });
      }
    },
    onReconnectStop: () => {
      if (readyState !== ReadyState.OPEN) {
        trackWsConnectionError('reconnect_exhausted', {
          reconnectAttempts: MAX_RECONNECT_ATTEMPTS,
          readyState,
        });
        setConnectionErrorVariant(resolveConnectionErrorVariant());
        setShowReloadMessage(true);
      }
    },
  });

  return { sendMessage, readyState };
};
